/**
 * Tareas del Panel de Internal (Kanban) — enums, labels y tipos compartidos
 * entre backend y frontend. Modelo copiado de timeflow (proyectos con color,
 * tareas con subtareas de un nivel + checklist inline).
 */

export const TASK_STATUSES = ['pending', 'in_progress', 'review', 'completed'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const TASK_PRIORITIES = ['low', 'medium', 'high', 'urgent'] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];

export const PROJECT_STATUSES = ['active', 'archived'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En progreso',
  review: 'Revisión',
  completed: 'Completada',
};

export const TASK_PRIORITY_LABEL: Record<TaskPriority, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  urgent: 'Urgente',
};

export const TASK_STATUS_COLOR: Record<TaskStatus, string> = {
  pending: '#94a3b8',
  in_progress: '#3b82f6',
  review: '#f59e0b',
  completed: '#10b981',
};

export const TASK_PRIORITY_COLOR: Record<TaskPriority, string> = {
  low: '#94a3b8',
  medium: '#3b82f6',
  high: '#f59e0b',
  urgent: '#ef4444',
};

/** Paleta de proyectos (9 swatches de timeflow). */
export const PROJECT_COLORS = [
  '#06b6d4', // cyan
  '#3b82f6', // blue
  '#6366f1', // indigo
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#ef4444', // red
  '#f59e0b', // amber
  '#10b981', // emerald
  '#64748b', // slate
] as const;
export type ProjectColor = (typeof PROJECT_COLORS)[number];
export const DEFAULT_PROJECT_COLOR: ProjectColor = PROJECT_COLORS[0];

export interface TaskProject {
  projectId: string;
  name: string;
  description?: string;
  color: string;
  status: ProjectStatus;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ChecklistItem {
  id: string;
  title: string;
  isCompleted: boolean;
}

export interface Task {
  taskId: string;
  projectId: string;
  /** Un solo nivel: una subtarea nunca tiene hijos. */
  parentTaskId?: string;
  title: string;
  description?: string;
  status: TaskStatus;
  priority: TaskPriority;
  assigneeEmail?: string;
  /** 'YYYY-MM-DD' (sin hora → sin corrimiento de zona horaria). */
  dueDate?: string;
  /** Orden dentro de la columna (fraccional: punto medio entre vecinos). */
  position: number;
  checklist: ChecklistItem[];
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface TaskAssignee {
  email: string;
  name: string;
}
